module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACEAAAAgCAYAAACcuBHKAAAACXBIWXMAAAsSAAALEgHS3X78AAABRklEQVRYhe2XzWnDQBCFvxjfowIMEaQBdxAfcnfSgTuw00kKCMQlJPdA7ArsdGCDC7ArWDMwYzZCfyv0d9ADoZ9Fq7fzZt6O7pxzdI1R5wz6QmJc8b0pEGWM7YFz0GySE4HHwuVjHTpnaGJKBHbABVinrHgBPABvwHvZSUPlMAkk5KuU8Q3wmyNVOrywbArCXDcOzrnYl0PC+KksL7rSphCrZIJv4MXkiPX8Jw+BQ4Mk0HxZmmxJn/hqgQDJfOqVWU203KQEZy19e2u5ZyROqs9ey6wN3BZrJKZ6fi5J4gN4rCkaMyMhEZgDPyVJ5BE4lkzuJ7uouoGJl9xnjK20yopw2y+qkgiz5QIMTY1hIGEYSBh6SaLW+s9B7A+ZWVnDukzcN4V//YS1d5H6fZYVN4VXsXi/5Y+012xDkrPfxQ0/xIbuSQBXXTQn0PCPx5oAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./static/img/dnx-90.png
// module id = AXkj
// module chunks = 1